const contentful = require("contentful-management");
const contentfulDeliveryApi = require("contentful");

const managementClient = contentful.createClient({
  accessToken: process.env.CONTENTFUL_MANAGEMENT_ACCESS_TOKEN,
});

const deliveryClient = contentfulDeliveryApi.createClient({
  accessToken: process.env.CONTENTFUL_ACCESS_TOKEN,
  space: process.env.CONTENTFUL_SPACE_ID,
  environment: process.env.CONTENTFUL_ENVIRONMENT ? process.env.CONTENTFUL_ENVIRONMENT : "master",
  resolveLinks: true,
  removeUnresolved: true
});

export const getLikes = async (entryId) => {
  const res = await managementClient
    .getSpace(process.env.CONTENTFUL_SPACE_ID)
    .then((space) => space.getEntry(entryId))
    .then((entry) => {
      return entry.fields.like["en-US"];
    })

    .catch(console.error);

  return res;
};

export const addLike = async (entryId, currentLikes) => {
  await managementClient
    .getSpace(process.env.CONTENTFUL_SPACE_ID)
    .then((space) => space.getEntry(entryId))
    .then((entry) => {
      entry.fields.like["en-US"] = currentLikes + 1;
      return entry.update();
    })
    .then((entry) => {
      return entry.publish();
    })
    .then((entry) => console.log(`Entry ${entry.sys.id} updated.`))
    .catch(console.error);
};

export const getEntryDeliveryApi = (entryId) => (
  deliveryClient.getEntries({"sys.id": entryId, include: 10})
    .then((entry) => entry.items[0].fields)
    .catch(console.error)
)